/* global $, element */

export function getBillingAddressValidation() {
    return {
        "billing_first_name": {
            required: true,
        },
        "billing_last_name": {
            required: true,
        },
        "billing_country": {
            required: true,
        },
        "billing_address_1": {
            required: true,
        },
        "billing_city": {
            required: true,
        },
        "billing_postal_code": {
            required: isStateZipRequired,
        },
        "billing_state": {
            required: isStateZipRequired,
        },
        "email": {
            isEmailValidationRequired: true,
        },
    }
}

export function getShippingAddressValidation() {
    return {
        "shipping_first_name": {
            required: isShippingRequired,
        },
        "shipping_last_name": {
            required: isShippingRequired,
        },
        "shipping_country": {
            required: isShippingRequired,
        },
        "shipping_address_1": {
            required: isShippingRequired,
        },
        "shipping_city": {
            required: isShippingRequired,
        },
        "shipping_state": {
            required: {
                depends: function (element) {
                    return (isShippingRequired(element) && isStateZipRequired(element));
                }
            }
        },
        "shipping_postal_code": {
            required: {
                depends: function (element) {
                    return (isShippingRequired(element) && isStateZipRequired(element));
                }
            }
        },
    }
}

export function getMailingAddressValidation() {
    return {
        "mailing_country": {
            required: true,
        },
        "mailing_address_1": {
            required: true,
        },
        "mailing_city": {
            required: true,
        },
        "mailing_state": {
            required: isStateZipRequired(element),
        },
        "mailing_postal_code": {
            required: isStateZipRequired(element),
        },
    }
}



function isStateZipRequired(elem) {
    var $form = $(elem).closest('.form-section');
    return $.inArray(
        $form.find('.country_picker').val(),
        ['CA', 'US']
    ) !== -1;
}


function isShippingRequired(elem) {
    var $copy_address = $(elem).closest('form').find("input[name='copy_address']");
    return (!($copy_address.is(":checked")));
}
